import { CalendarDays } from "lucide-react";
import ComingSoon from "@/components/ComingSoon";

export default function CalendarPage() {
  return (
    <ComingSoon
      icon={CalendarDays}
      title="Календарь"
      description="Отдельно от планирования работ"
      note="Больничные, отпуска, показы объектов, встречи и обучение сотрудников."
    />
  );
}
